import AtlassianNavigation from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/docs/ert/skeleton-icon-button";
import AppSwitcher from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/AppSwitcher";
import Create from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/Create";
import Help from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/Help";
import Notifications from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/Notifications";
import PrimaryButton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/PrimaryButton";
import PrimaryDropdownButton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/PrimaryDropdownButton";
import IconButton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/IconButton";
import ProductHome from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/ProductHome/product-home";
import CustomProductHome from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/ProductHome/custom-product-home";
import Profile from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/Profile";
import Search from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/Search";
import Settings from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/Settings";
import SignIn from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/SignIn";
import NavigationSkeleton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/src/components/AtlassianNavigation/skeleton";
import SkeletonCreateButton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/docs/ert/skeleton-create-button";
import SkeletonIconButton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/docs/ert/skeleton-icon-button";
import SkeletonPrimaryButton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/docs/ert/skeleton-primary-button";
import SkeletonSwitcherButton from "!!extract-react-types-loader!../../../../../../packages/design-system/atlassian-navigation/docs/ert/skeleton-switcher-button";
import * as React from 'react';
export default {
  AtlassianNavigation,
  AppSwitcher,
  Create,
  Help,
  Notifications,
  PrimaryButton,
  PrimaryDropdownButton,
  IconButton,
  ProductHome,
  CustomProductHome,
  Profile,
  Search,
  Settings,
  SignIn,
  NavigationSkeleton,
  SkeletonCreateButton,
  SkeletonIconButton,
  SkeletonPrimaryButton,
  SkeletonSwitcherButton,
  React
};